export const VAT_RATES = [19, 7, 0];

export default VAT_RATES;
